import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { formatCurrency } from "uikit"
import { NavLink } from "react-router-dom"

const MXHCPlan = ({
  id,
  type,
  personName,
  monthly_premium,
  people_coverage,
  label,
  is_hdhp
}) => (
  <Card>
    <Card.Content>
      <Grid style={{ position: "relative", height: "170px" }}>
        <Grid.Row columns={2} verticalAlign="top">
          <Grid.Column>
            <NavLink
              to={`/organize/income+benefits/benefits/${id}/${type.toLowerCase()}`}
              className="navlink"
            >
              <span className="GenericCard__LinkTitle">
                {label}
                <Icon name="chevron right" size="small" />
              </span>
              <p className="greyed-text">
                Coverage:{" "}
                {`${people_coverage[0].toUpperCase()}${people_coverage.substring(
                  1
                )}`}
              </p>
            </NavLink>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="GenericCard__Balance">
              {typeof monthly_premium === "number"
                ? formatCurrency(monthly_premium)
                : monthly_premium}
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2} verticalAlign="bottom">
          <Grid.Column>
            <p className="greyed-text">{personName}</p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="greyed-text">{is_hdhp ? "HDHP" : "Non-HDHP"}</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)

export default MXHCPlan
